import { demoWeeklyHighlightsBlock } from "@/lib/content-blocks-data";
import { WeeklyHighlightsSection } from "./weekly-highlights-section";

export function ThisWeekBand() {
  return <WeeklyHighlightsSection block={demoWeeklyHighlightsBlock} />;
}
